import { Pipe, PipeTransform } from '@angular/core';

declare var _: any;

@Pipe({
    name: 'checkPointMaster'
})

export class CheckPointMasterPipe implements PipeTransform {

    transform(array: any[], query: string): any {
        if (query) {
            if (_.filter(array, row => row.checkPoint.toLowerCase().indexOf(query.toLowerCase()) > -1) != '') {
                return _.filter(array, row => row.checkPoint.toLowerCase().indexOf(query.toLowerCase()) > -1);
            } else {
                return;
            }
        }
        return array;
    }

}
